<!--
  功能：功能描述
  作者：missfox
  邮箱：missfoxw@163.com
  时间：2021年09月17日 14:40:33
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div class="home" @touchstart.capture="nursingCapture">

    <transition name="tabs">
      <myHead v-if="!isFlatThreeFullScreen "></myHead>
    </transition>
    <leftFilter :swtich='filterSwitch'></leftFilter>
    <div :class="[isFlatThreeFullScreen?'main-FullScreen':'','home-main']" >
      <router-view v-if="reloadPage"></router-view>
    </div>
    <el-image v-drag v-if="$route.meta.headIcon!==false" class="head-img head-img-left" @click="goHome" :src="newHome"></el-image>
  </div>
</template>


<script>
import {pos,nfcReadHandCallback,posRun} from '@/tool/posRun'
import {timeCompared} from '@/tool'
import axios from 'axios';
import { mapState,mapGetters,mapMutations,mapActions} from 'vuex'
import myHead from '@/common/my-head.vue'
import leftFilter from '@/common/left-filter.vue'
import newHome from '@/assets/imgs/new-home.png'
//pos机读卡回调函数指定在window对象下
window.nfcReadHandCallback=nfcReadHandCallback

export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {
    myHead,
    leftFilter
  },
  // 组件状态值
  data () {
    return {
      pos,
      newHome,
      isDefaultShifts:false,
      reloadPage:true,
    }
  },
  // 计算属性
  computed: {
    ...mapGetters(['user','isFlatThreeFullScreen']),
    ...mapState(['Items','isNeedNursing','timer','cardId']),
    ...mapState('filter', {
      filterSwitch: state => state.switch
    }),

  },
  // 侦听器
  watch: {
    filterSwitch(val){
      if(val){
        clearTimeout(this.timer)
      }else{
        if(this.$route.name=='nursingOne'){
          this.resetTime()
        }
      }
    },
    //pos机找读卡完成后触发
    "pos.readNum":{
      handler: function(){
        //登录页刷卡则默认为操作员刷卡，进行刷卡登录判断
        if(this.$route.name=='login'){
          this.login()
        //不是登录页，则默认为老者刷卡，进行刷卡项目判断
        }else{
          this.checkNfcId(this.$route.query.nfcid)
          // this.$notify.error({
          //   title: '错误',
          //   message: `${this.user.UserName}已登录`,
          //   offset: 100,
          //   customClass:'notifyClass'
          // });
        }
      },
    },
    $route: {
      handler: function(val){
        console.log(val);
        if(!this.pos.over){
          posRun()
        }
        let grpid=val.query.grpid||val.query.grpId
        if(val.query.comId&&grpid){
          localStorage.setItem('comId',val.query.comId)
          localStorage.setItem('grpid',grpid)
          axios.defaults.headers['X-Auth-Grpid'] = localStorage.getItem('grpid');
          axios.defaults.headers['X-Auth-ComId'] = localStorage.getItem('comId');
        }
        if(this.$route.name!='login'&&this.isNeedNursing){
          this.getNursingInformation()
          //默认班次
          if(!this.isDefaultShifts){
            let date=new Date(),h=String(date.getHours()),m=String(date.getMinutes());
            h=h.length>1?h:'0'+h
            m=m.length>1?h:'0'+m
            this.isDefaultShifts=true
            this.updateSelectVal({arr:[timeCompared(`${h}:${m}`)],type:2})
          }
        }
      },
      immediate:true
    },
  },


  // 组件方法
  methods: {
    ...mapActions(['getNursingInformation']),
    ...mapMutations(['updatedUser','updateFullScreen','resetTime','updateFlat','updateCardId']),
    ...mapMutations('filter', ['updateSelectVal']),
    nursingCapture(e){
      if(this.$route.name=="nursingOne"&&!this.filterSwitch){
        if(this.isFlatThreeFullScreen){
          this.updateFullScreen(false)
          e.stopPropagation();
        }
        this.resetTime()
      }
    },


    //登录
    login(errTip='请先登录护理员账号'){
      const loading = this.$loading({
        lock: true,
        text: '登录中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$axios.post(`/Pad/SwipeLogin?carNo=${this.pos.nfcid}`,{
        errTip
      })
      .then((res)=>{
        let userInfo=res.data.obj
        loading.close();
        this.updatedUser(userInfo)
        this.updateCardId(this.pos.nfcid)

        // 判断是护士还是医生登录
        localStorage.setItem('active',userInfo.DepartName === '医疗'? 'D': 'N')
        // 清除忘记密码登录得用户信息
        localStorage.removeItem('userName')
        localStorage.removeItem('hyToken')
        // 此处的方法比较骇客，可以通过router-view加key的方法实现相同的路由界面页面刷新
        if (this.$route.fullPath === '/main') {
          this.reload()
        }else {
          this.$router.push({
          name:'main'
        })
        }

        this.$message({
          message: `${userInfo.UserName}登录成功!`,
          type: 'success',
          customClass:"custom-message"
        });
      }).catch(err=>{
        loading.close();
      })
    },
    // 刷新子路由重新执行渲染
    reload(){
      this.reloadPage=false
      this.$nextTick(function(){
        this.reloadPage=true
      })
    },

    //验证nfcid
    checkNfcId(){
      let arr=this.Items.filter(item => new String(item.InductionCar).indexOf(new String(this.pos.nfcid)) > -1)
      if(arr.length){
        if(this.$route.name=='nursingOneImplement'){
          this.$router.replace({
            name:"nursingOneImplement",
            query: { Id:arr[0].ProfileId }
          })
        }else{
          this.$router.push({
            name:"nursingOneImplement",
            query: { Id:arr[0].ProfileId }
          })
        }
      }else{
        if(this.cardId==this.pos.nfcid){
          this.$notify.error({
            title: '错误',
            message: `该操作员已登录`,
            offset: 100,
            customClass:'notifyClass'
          });
        }else{
          this.login('未找到护理老者')
        }
      }
    },
    //扫码回调
    nfcScanHandCallback(str,minute=5){
      console.log(str);
      let arr=str.split(",")
      if(arr.length){
        let Id = arr[0]
        // let time = parseInt(arr[1])
        // let nowTime = new Date().getTime()
        // if((nowTime-time)>(minute*60*1000)){
        //   this.$notify.error({
        //     title: '错误',
        //     message: `二维码有效期为${minute}分钟，此二维码已过期！`,
        //     offset: 100,
        //     customClass:'notifyClass'
        //   });
        // }else{
        // this.$router.push({ name: 'nursingOneImplement', query: { Id }})
        // }
        this.$store.commit('setScanCode',Id.toLocaleLowerCase())
        this.$router.push({ name: 'nursingOneImplement', query: { Id:Id.toLocaleLowerCase() }})
      }else{
          this.$notify.error({
            title: '错误',
            message: `此二维码无效，请重新生成！`,
            offset: 100,
            customClass:'notifyClass'
          });
      }
    },
    //检测手机/平板/电脑，经测试有些端检测失败
    checkType(){
      var os = function() {
        var ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian;
        return {
          isTablet: isTablet,
          isPhone: isPhone,
          isAndroid: isAndroid,
          isPc: isPc
        };
      }();
      this.updateFlat(os.isTablet||os.isPc)
    },
    goHome(){
      this.$router.push({
        name:'main'
      })
    }

  },
  // 以下是生命周期钩子   注：没用到的钩子请自行删除
  /**
  * 在实例初始化之后，组件属性计算之前，如data属性等
  */
  beforeCreate () {
  },
  /**
  * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
  */
  created () {
    // this.checkType()
    // console.log("初始化");
    window.nfcScanHandCallback=this.nfcScanHandCallback
  },
  /**
  * 在挂载开始之前被调用：相关的 render 函数首次被调用。
  */
  beforeMount () {
  },
  /**
  * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
  * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
  */
  mounted () {




  },
  /**
  * 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
  * 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
  */
  beforeUpdate () {
  },
  /**
  * 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
  * 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
  */
  updated () {
  },
  /**
  * keep-alive 组件激活时调用。 仅针对keep-alive 组件有效
  */
  activated () {
  },
  /**
  * keep-alive 组件停用时调用。 仅针对keep-alive 组件有效
  */
  deactivated () {
  },
  /**
  * 实例销毁之前调用。在这一步，实例仍然完全可用。
  */
  beforeDestroy () {
  },
  /**
  * Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，
  * 所有的事件监听器会被移除，所有的子实例也会被销毁。
  */
  destroyed () {
  }
}
</script>

<style scoped>
.home-main{
  padding-top: 44px;
  min-height: calc(100vh - 44px);
  background: #F7F8FA;
}
.home >>> .el-dialog{
    border-radius: 5px;
}
.home >>> .el-dialog__header{
    height: 0px;
    padding: 0px;
}
.home >>> .el-dialog__body{
    padding: 0px;
}
.home >>> .el-dialog{
    margin-top: 0px !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
.dialog-main{
  padding: 10px;
  font-size: 12px;
}

.main-FullScreen{
  padding-top: 0px;
  min-height: 100vh;
}

.head-img{
  position: fixed;
  right: 30px;
  bottom: 60px;
  height: 42px;
  width: 42px;
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue